export const ACTIONS = {
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_CURRENT_LANGUAGE: "SET_CURRENT_LANGUAGE",
  SET_SELECTED_BLOCK: "SET_SELECTED_BLOCK",
  ADD_BLOCK: "ADD_BLOCK",
  UPDATE_BLOCK: "UPDATE_BLOCK",
  REMOVE_BLOCK: "REMOVE_BLOCK",
  UPDATE_BLOCK_ORDER: "UPDATE_BLOCK_ORDER",
  RESET_CURRENT_PAGE: "RESET_CURRENT_PAGE",
};

export const setCurrentPage = (page) => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.SET_CURRENT_PAGE,
    page: page,
  });
};

export const setCurrentLanguage = (language) => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.SET_CURRENT_LANGUAGE,
    language: language,
  });
};

export const setSelectedBlock = (blockId) => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.SET_SELECTED_BLOCK,
    blockId: blockId,
  });
};

export const addBlock = (block) => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.ADD_BLOCK,
    block: block,
  });
};

export const updateBlock = (blockId, config) => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.UPDATE_BLOCK,
    blockId: blockId,
    config: config,
  });
};

export const removeBlock = (blockId) => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.REMOVE_BLOCK,
    blockId: blockId,
  });
};

export const updateBlockOrder = (blocks) => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.UPDATE_BLOCK_ORDER,
    blocks: blocks,
  });
};

export const resetCurrentPage = () => (dispatch, getState) => {
  dispatch({
    type: ACTIONS.RESET_CURRENT_PAGE,
  });
};


